export const isGTMEnabled = JSON.parse(process.env.REACT_APP_GTM_ENABLED) && process.env.REACT_APP_GTM_ID?.length;
export const isGTAGEnabled = JSON.parse(process.env.REACT_APP_GTAG_ENABLED);
